/*
 * Re-asserts the dated backorder message in the product-stock-alert block
 * (VIS-770). The block SSRs the message via snippets/shipping-date.liquid for
 * first paint; this recomputes the date with the shared shippingDate() — the
 * runtime source of truth — and overwrites the text if it disagrees, so a
 * drifted Liquid walk or a cached page shows the wrong date only until this
 * module loads. Inputs (lead time, today, months, wording) all come from the
 * server via data attributes; nothing here trusts the shopper's clock.
 *
 * Only loaded on a backorder state, and never on contact-lens PDPs, where
 * lens-configurator.js owns the whole message.
 */
import { shippingDate } from '@theme/shipping-date';

for (const message of document.querySelectorAll('[data-shipping-date]')) {
  const date = shippingDate(
    Number(message.dataset.leadTime),
    message.dataset.today || '',
    (message.dataset.months || '').split(',')
  );
  // No date computable (lead time gone, malformed inputs): keep the SSR text,
  // which is the undated fallback in exactly that case.
  if (!date) continue;

  const text = (message.dataset.datedTemplate || '').replace('{{ date }}', date);
  if (text && message.textContent !== text) message.textContent = text;
}
